











































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Types
import { IFiltersOptions } from "@/models/tables";

@Component({
  components: {
    "category-select-field": () =>
      import(
        "@/components/app/global/templates/templateFields/categorySelectField.vue"
      ),
    "webhook-category-triggers-selector": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookCategoryTriggersSelector.vue"
      )
  }
})
export default class CategoryDataSelectorFilter extends Vue {
  // Props

  @Prop({ required: true })
  public value!: string[];

  @Prop({ required: true })
  public options!: IFiltersOptions[];

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: () => [] })
  public disabledCategoryIds!: string[];

  // Data

  public categoryId = null;
  public selectAll = false;

  // Getters

  public get dataSelected() {
    return this.value;
  }
  // Setters

  public set dataSelected(value) {
    this.$emit("input", value);
  }

  // Life-cycle methods

  public created() {
    this.categoryId = _.isEmpty(this.value)
      ? _.get(this.options, "[0].value", null)
      : _.get(
          _.find(this.options, option =>
            _.some(option.options, ["value", this.value[0]])
          ),
          "value",
          null
        );
    this.onDataSelectedChange();
  }

  // Methods

  public clearAllDataSelected() {
    this.$set(this, "dataSelected", []);
  }

  public handleSelectAllClick(value) {
    if (value) {
      this.$set(
        this,
        "dataSelected",
        _.map(this.categoryData, categoryData => categoryData.value)
      );
      return;
    }

    this.clearAllDataSelected();
  }

  // Computed

  public get categoryData() {
    return _.get(
      _.find(this.options, ["value", this.categoryId]),
      "options",
      []
    );
  }

  public get categories() {
    return _.map(this.options, option => {
      return {
        id: option.value,
        name: option.label
      };
    });
  }

  // Watchers

  @Watch("dataSelected")
  public onDataSelectedChange() {
    this.selectAll = !_.some(
      this.categoryData,
      categoryData => !this.dataSelected.includes(categoryData.value as string)
    );
  }
}
